"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreloadedState = exports.getValues = exports.toIdsMap = exports.toIdsArray = void 0;
const keyBy_1 = __importDefault(require("lodash/keyBy"));
const get_1 = __importDefault(require("lodash/get"));
const env_1 = require("../env");
const toIdsArray = (items, idKey = 'id') => items.map((item) => item[idKey]);
exports.toIdsArray = toIdsArray;
const toIdsMap = (items, idKey = 'id') => (0, keyBy_1.default)(items, idKey);
exports.toIdsMap = toIdsMap;
const getValues = (idsArray, itemsMap) => itemsMap ? idsArray.map((id) => itemsMap[id]).filter((item) => !!item) : [];
exports.getValues = getValues;
const getPreloadedState = (key, initialState) => (env_1.isBrowser && (0, get_1.default)(window.__PRELOADED_STATE__, key)) || initialState;
exports.getPreloadedState = getPreloadedState;
//# sourceMappingURL=slices.js.map